import { SummaryStatsCard } from '@exam-center/components';
import { useExamEventDetails } from '@exam-center/exam-event-management';
import { useGetExamEventExamineeCountSummaryForProctoringQuery } from '@exam-center/graphql';
import { BarChartIcon, AssignmentTurnedInOutlinedIcon, Flex, Text } from '@shared/components';

export default function ExamineeSummaryDashboard() {
  const { examEvent } = useExamEventDetails();

  const { data, loading: isLoading } = useGetExamEventExamineeCountSummaryForProctoringQuery({
    variables: {
      getExamEventExamineeCountSummaryForProctoringInput: {
        examEventId: examEvent.id,
      },
    },
    fetchPolicy: 'cache-and-network',
    pollInterval: 10_000,
  });

  const {
    total = 0,
    eKyc = 0,
    registrationStatusRegistered = 0,
    absent = 0,
    passed = 0,
    failed = 0,
    canceled = 0,
  } = data?.ecGetExamEventExamineeCountSummaryForProctoring ?? {};

  const isInitialLoading = isLoading && !data;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(2) }}>
        <Flex sx={{ alignItems: 'center', gap: (theme) => theme.spacing(1) }}>
          <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 20 }} />
          <Text variant='body1'>ข้อมูลยืนยันตัวตน</Text>
        </Flex>
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <SummaryStatsCard
            title='ทำ e-KYC แล้ว / ผู้สมัครทั้งหมด'
            displayValue={`${eKyc}/${total} คน`}
            loading={isInitialLoading}
            color='info'
            tooltipText='จำนวนผู้สมัครทำยืนยันตัวตนผ่านระบบ e-KYC สำเร็จ'
          />
          <SummaryStatsCard
            title='ผู้ที่ลงทะเบียน ณ วันสอบ'
            displayValue={`${registrationStatusRegistered} คน`}
            loading={isInitialLoading}
            color='deepPurple'
            tooltipText={
              'จำนวนผู้สมัครที่ลงทะเบียนเข้าสอบ ณ วันสอบ\nที่ผ่านการ Dip Chip หรือยืนยันด้วยเอกสาร'
            }
          />
        </Flex>
      </Flex>

      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(3) }}>
        <Flex sx={{ alignItems: 'center', gap: (theme) => theme.spacing(1) }}>
          <BarChartIcon sx={{ fontSize: 20 }} />
          <Text variant='body1'>ข้อมูลการสอบ</Text>
        </Flex>
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <SummaryStatsCard
            title='ผู้ที่สอบผ่าน'
            displayValue={`${passed} คน`}
            color='success'
            loading={isInitialLoading}
          />
          <SummaryStatsCard
            title='ผู้ที่สอบไม่ผ่าน'
            displayValue={`${failed} คน`}
            color='error'
            loading={isInitialLoading}
          />
          <SummaryStatsCard
            title='ผู้ที่ถูกยกเลิก'
            displayValue={`${canceled} คน`}
            color='warning'
            loading={isInitialLoading}
            tooltipText='ผู้ที่ถูกยกเลิกสิทธิ์การสอบโดยผู้คุมสอบ'
          />
          <SummaryStatsCard
            title='ผู้ที่ขาดสอบ'
            displayValue={`${absent} คน`}
            loading={isInitialLoading}
            tooltipText={
              <Text variant='caption' component='div'>
                ผู้สมัครที่ไม่ได้เข้าสอบตามเงื่อนไข ได้แก่
                <ul style={{ margin: '4px 0 0', paddingLeft: 20 }}>
                  <li>ไม่มาลงทะเบียน ณ วันสอบ</li>
                  <li>เข้าสู่ระบบช้าเกิน 30 นาทีหลังเริ่มสอบ</li>
                  <li>ทำข้อสอบไม่ครบทุกช่วง</li>
                  <li>ถูกระงับสิทธิ์การสอบ (Blocklist)</li>
                </ul>
              </Text>
            }
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
